const messages = {
  bonus: {
    title: "Prehľad bonusových kreditov",
    description: "Bonusy v eurách sa prideľujú zúčastneným spoločnostiam na základe zaslaných predajných údajov.",
    lastMonth: "Minulý mesiac",
    currentMonth: "Aktuálny mesiac",
    totalCurrentYear: "Spolu za aktuálny rok",
    totalLastYear: "Spolu za minulý rok",
  },
  points: {
    title: "Prehľad bodových kreditov",
    period: "Prebiehajúci kalendárny rok ({year})",
    totalAwarded: "Celkovo pridelené body",
    redeemed: "Využité body",
    totalBalance: "Celkový zostatok bodov",
    redemptionRate: "Uplatnené body ako percento pridelených bodov",
    averageAwarded: "Priemer pridelených bodov na kúpenú pneumatiku",
    standardAwarded: "Čisté body z vypočítaných predajných riadkov, vrátane vratiek",
    bsPlusInclBooster: "Body z predajných riadkov s kladným množstvom",
    perTire: "Uplatnené body na kúpenú pneumatiku",
  },
  tires: {
    title: "Prehľad množstva pneumatík",
    description: "Pneumatiky zakúpené zákazníkmi",
    prevMonth: "Predchádzajúci mesiac",
    totalLastYear: "Spolu za minulý rok",
    purchaseIndirect: "Nákup cez veľkoobchod (nepriamy)",
    purchaseDirect: "Nákup cez veľkoobchod (priamy)",
    totalCurrentYear: "Spolu za aktuálny rok",
    currentMonth: "Aktuálny mesiac",
  },
  participating: {
    title: "Prehľad zúčastnených zákazníkov",
    description: "Spoločnosti, ktoré sa zaregistrujú do BRIDGESTONE PLUS, môžu byť priradené podľa čísla zákazníka.",
    total: "Spolu",
    newThisMonth: "Noví tento mesiac",
    newThisYear: "Noví tento rok",
    createdInCurrentMonth: "Vytvorené v aktuálnom mesiaci (administrátorom)",
    loginsCurrentYear: "Prihlásenia v aktuálnom roku (po prijatí podmienok)",
  },
  brand: {
    title: "Značka",
    description: "Vaše nákupy podrobne",
    centerTitle: "Podľa\nznačky",
  },
  rim: {
    title: "Disk",
    centerTitle: "Podľa veľkosti\ndisku",
  },
  tireGoals: {
    title: "Ciele pneumatík",
    subtitle: "Získajte body za nákup pneumatík.",
    centerTitle: "Podľa veľkosti\npneumatiky",
    tiresRemaining: "Zostávajúce pneumatiky",
    progressionTarget: "Cieľ postupu: ",
    pointsEarnedPurchases: "body získané\n" + "vašimi\n" + "nákupmi",
    pointsEarnedBoosters: "body získané\n" + "prostredníctvom\n" + "boosterov",
    purchasesDetail: "Vaše nákupy podrobne",
    cta: "Zistite viac o svojich bodoch",
    pointsTitle: "Vaše body",
    pointsSubtitle: "Body získané za nákupy Bridgestone",
    achievementsTitle: "Vaše úspechy",
    achievementsSubtitle: "Váš ročný záväzok:",
    achievementsSubtitle2: "pneumatík",
  },
  score: {
    title: "Skóre",
    total: "Spolu",
    credits: "Kredity v",
    deductions: "Odpočty v",
        unlockedPoints: "Odomknuté body",
        pendingPoints: "Čakajúce body",
  },
  score_extended: {
    title1: "Bodový zostatok",
    title2: "Bonus v eurách",
    balance: "Bodový zostatok",
    bonus_in_euro: "Bonus v eurách",
    date: "Dátum",
    added_points: "Pridané body v",
    total_bands: "Spolu značiek",
    goal: "Cieľ",
    tyres_previous_year: "Pneumatiky predané minulý rok",
    tyres_current_year: "Pneumatiky predané tento rok",
    target_this_year: "Predajný cieľ na tento rok",
    bonus_this_year: "Získaný bonus (€)",
    loyal_minimum: "Minimálna úroveň lojality",
    bonus_multiplier: "Sadzba násobiteľa bonusu",
  },
  lastImport: {
    label: "Posledný import predajných údajov:",
    on: "",
  },
  wholesalerTable: {
    title: "Zúčastnení zákazníci podrobne",
    description: "Nižšie nájdete spoločnosti, ktoré sa zaregistrovali do BRIDGESTONE PLUS s číslom zákazníka vašej spoločnosti. Môžete použiť filtre na iné triedenie alebo vyhľadávanie zákazníkov.",
    columns: {
      customer_number: "Číslo zákazníka",
      address_company_name: "Spoločnosť",
      address_street: "Ulica a číslo",
      address_postal_code: "PSČ",
      address_city: "Mesto",
      last_registration: "Posledná registrácia",
      network: "Sieť",
      profile_group: "Skupina",
      tires_amount: "Počet pneumatík",
      point_balance: "Bodový zostatok",
      bonus: "Bonus",
      details: "Detaily",
    },
    searchPlaceholder: "Hľadať",
  },
  dealerTable: {
    columns: {
      date: "Dátum",
      wholesaler_bs_plus: "Veľkoobchod BS+",
      customer_number: "Číslo zákazníka",
      article: "Položka",
      brand: "Značka",
      product: "Produkt",
      type: "Typ",
      inch: "Palec",
      season: "Sezóna",
      amount: "Množstvo",
      points: "Body",
      activity: "Aktivita",
      total_points: "Body spolu",
    },
    title: "Tabuľka dealerov",
    description: "Prehľad aktivít dealerov",
  },
  business_units: {
    title: "Obchodné jednotky",
    centerTitle: "Podľa\njednotky",
  },
  season: {
    title: "Sezóna",
    centerTitle: "Podľa obdobia\nroka",
  },
};

export default {
  messages,
};
